<div class="agpr-formField agpr-textField">
    <div
        *ngIf="field.label"
        class="agpr-formField-label"
    >
        {{ field.label | localize }}
    </div>
    <agpr-dropdown
        [id]="id + '.dropdown'"
        [options]="allOptions"
        [(ngModel)]="selectedOption"
        [placeholder]="field.placeholder"
        (ngModelChange)="onDropdownChanged($event.value)"
        ariaLabel="Reports.formField.selectMetrictoAnalyseLabel"
        [ariaLabelledBy]="field.headingId"
    ></agpr-dropdown>
    <div
        *ngIf="field.description"
        class="agpr-formField-description"
    >
        {{ field.description | localize }}
    </div>
</div>
